import { IManhattanBundle } from "../../../../entities/manhattan/bundle/types";
import ActionTypes from "../../../../constants/ActionTypes";
import { IRequestFetchStandardBundleAction, ISetManhattanBundleAction } from "./types";

export function requestFetchStandardBundleAction(params: object): IRequestFetchStandardBundleAction {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE.FETCH,
    params,
  };
}

export function setManhattanBundleAction(bundle: IManhattanBundle): ISetManhattanBundleAction {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE.SET,
    payload: bundle,
  };
}

export function bundleValidatorAction(bundle: IManhattanBundle) {
  return {
    type: ActionTypes.MANHATTAN.BUNDLE.VALIDATOR,
    payload: bundle
  };
}
